import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetReports = () =>
  useMutation({
    mutationFn: (data) => client(`reports/service/calls/v2`, { data }),
  });

export const useGetAllCallsReports = () =>
  useMutation({
    mutationFn: (data) => client(`reports/all/calls/v2`, { data }),
  });
export const useSubmitReport = () =>
  useMutation({
    mutationFn: (data) =>
      client(`reports/submit/request`, {
        data,
        successMessage: "Report request submitted successfully!",
      }),
  });

export const useGetReportRequests = () =>
  useMutation({
    mutationFn: () =>
      client(`reports/requests?reportType=MaintenanceServicesReport`),
  });

export const useGetServiceReportRequests = () =>
  useMutation({
    mutationFn: () =>
      client(`reports/requests?reportType=ServiceTicketsReport`),
  });
